<template>
	<div class="manage">
		<div style="" class="top">
			<el-row>
				<el-col :span="1">
					<el-input v-model="page_size" @blur="ps_input"  placeholder="行数">
					</el-input>
				</el-col>
				<el-col :span="2">
					<el-input v-model="form.brand_name"  placeholder="品牌">
					</el-input>
				</el-col>
				<el-col :span="2">
					<el-input v-model="form.name"  placeholder="品名">
					</el-input>
				</el-col>
				<el-col :span="2">
					<el-input v-model="form.model"  placeholder="型号">
					</el-input>
				</el-col>
				<el-col :span="6">
					<el-input v-model="form.order_no"  placeholder="订货号">
						<template #append>
							<el-button type="primary" class="button" style="width:60px" @click="grabble">
								<el-icon color="#fff" size="12px" class="no-inherit">
									<Search />
								</el-icon>
							</el-button>
						</template>
					</el-input>
				</el-col>
				<el-col :xs="24" :sm="12" :md="6" :lg="6" :xl="5" style="text-align:left">
					<el-button color="#ff8a5c" style="color:#fff;margin-left: 0.75rem;" @click="showShare_click()">分享</el-button>
					<el-button color="#ff8a5c" style="color:#fff" @click="updatestorage()">保存</el-button>
				
					<el-button color="#ff8a5c" style="color:#fff" @click="checkundostorage">退回</el-button>
				</el-col>
				<el-col :xs="24" :sm="12" :md="5" :lg="5" :xl="5" style="text-align:right">
					
					<el-button color="#ff8a5c" style="color:#fff" @click="shelves_lise(1)">上架</el-button>
					<el-button color="#ff8a5c" style="color:#fff" @click="shelves_lise(0)">下架</el-button>
				</el-col>
			</el-row>
			<el-row>
				<el-col :span="24" class="table">
					<div ref="height_top">
						<!-- <el-table-v2
					    :columns="columns"
					    :data="tableData"
					    :width="700"
					    :height="400"
					    fixed
					  /> -->
						<el-table :row-style="addStyle"  :data="tableData" row-key="key" :row-class-name="tableRowClassName" @cell-click="tabClick" @row-click="rowClick" ref="singleTable" :show-summary="true" :summary-method="getSummaries" @selection-change="handleSelectionChange" :height="tableHeight" @filter-change="filterHandler" v-loading="loading" @row-dblclick="rowDblclick" :header-cell-style="{'background-color': '#e5e5e5'}" size="small" style="width: 100%">
							<el-table-column type="selection" width="55" />
							<el-table-column prop="key" label="行号" width="55" />
							<el-table-column prop="img" label="图片" width="55" show-overflow-tooltip>
								<template #default="scope">
									<div v-if="scope.row.img.length <= 0">
										<el-icon size="20" style="top: 0.3rem;">
											<PictureFilled />
										</el-icon>
										<!-- <i class="el-icon-picture" style=" color: #ccc; margin-top:4px;"></i> -->
									</div>
									<div v-else>
										<el-icon size="20" style=" color: #29afa5;top: 0.3rem; " @click="preview(scope.row,scope.row.img)">
											<PictureFilled />
										</el-icon>
										<!-- <i class="el-icon-picture" style=" color: #29afa5; margin-top:4px;cursor: pointer;"></i> -->
									</div>
								</template>
							</el-table-column>
							<el-table-column prop="brand_name" label="品牌" width="90" show-overflow-tooltip />
							<el-table-column prop="name" label="品名" width="100" show-overflow-tooltip />
							<el-table-column prop="model" label="型号" width="120" show-overflow-tooltip />
							<el-table-column prop="order_no" label="订货号" width="120" show-overflow-tooltip />
							<el-table-column prop="price" label="列表价" width="80" align="right" header-align="right" show-overflow-tooltip />
							<el-table-column prop="discount" label="折扣" width="60" align="right" header-align="right" show-overflow-tooltip />
							<el-table-column prop="sur_num" label="数量" width="60" align="right" header-align="right" show-overflow-tooltip />
							<el-table-column prop="real_price" label="单价" width="80" align="right" header-align="right" show-overflow-tooltip />
							<el-table-column prop="real_money" label="金额" width="80" align="right" header-align="right" show-overflow-tooltip />
							<el-table-column prop="tsw_ratio" label="脱手比例" width="90" align="right" header-align="left" show-overflow-tooltip>
								<template #default="scope">
									<span v-if="scope.row.index === tabClickIndex && tabClickcolumn=='1'" @click.stop>
										<el-input v-bind:class="{'row_input': row_input!==scope.row.index+'1' }" :ref="'save_input'+scope.row.index+'1'" :id="'save_input'+scope.row.index+'1'" v-model="scope.row.tsw_ratio" maxlength="300" size="mini" @blur="facePriceblur($event,scope.row,scope.row.index,'tsw_ratio')" @focus="inputfocus(scope.row.index+'1',$event)" @input="inputBlurDiscount(scope.row.index,$event,scope.row)" />
									</span>
									<span v-else>
										{{scope.row.tsw_ratio}}
									</span>
								</template>
							</el-table-column>
							<el-table-column prop="tsw_price" label="脱手单价" width="90" align="right" header-align="left" show-overflow-tooltip>
								<template #default="scope">
									<span v-if="scope.row.index === tabClickIndex && tabClickcolumn=='2'" @click.stop>
										<el-input v-bind:class="{'row_input': row_input!==scope.row.index+'2' }" :ref="'save_input'+scope.row.index+'2'" :id="'save_input'+scope.row.index+'2'" v-model="scope.row.tsw_price" maxlength="300" size="mini" @blur="facePriceblur($event,scope.row,scope.row.index,'tsw_price')" @focus="inputfocus(scope.row.index+'2',$event)" @input="inputBlurTsw_price(scope.row.index,$event,scope.row)" />
									</span>
									<span v-else>
										{{scope.row.tsw_price}}
									</span>
								</template>
							</el-table-column>
							<el-table-column prop="tsw_money" label="脱手金额" width="80" align="right" header-align="left" show-overflow-tooltip />
							<el-table-column prop="stock_type_txt" label="货物状态" width="150" show-overflow-tooltip column-key="stock_type_txt" :filters="[{
					text: '滞纳、在保、包附完好',
					value: '滞纳、在保、包附完好'
				},
				{
					text: '滞纳、在保、包附破损',
					value: '滞纳、在保、包附破损'
				},
				{
					text: '滞纳、过保、包附完好',
					value: '滞纳、过保、包附完好'
				},
				{
					text: '滞纳、过保、包附破损',
					value: '滞纳、过保、包附破损'
				},
				{
					text: '二手、在保、包附完好',
					value: '二手、在保、包附完好'
				},
				{
					text: '二手、在保、包附破损',
					value: '二手、在保、包附破损'
				},
				{
					text: '二手、过保、包附完好',
					value: '二手、过保、包附完好'
				},
				{
					text: '二手、过保、包附破损',
					value: '二手、过保、包附破损'
				}
			]"/>
							<el-table-column prop="is_up_shelves" label="状态" width="80" column-key="is_up_shelves" :filters="[
					        { text: '已上架', value: '1' },
					        { text: '待审核', value: '2' },
					        { text: '已下架', value: '0' },
					      ]">
								<template #default="scope">
									<span v-if="scope.row.is_up_shelves==1">
										已上架
									</span>
									<span v-else-if="scope.row.is_verify==1">
										待审核
									</span>
									<span v-else>
										已下架
									</span>
								</template>
							</el-table-column>
							<!--  <el-table-column prop="" label="操作"  width="80"  >
					     <template #default="scope">
					     		<span v-if="scope.row.is_up_shelves==1">
					     			<el-button size="small" color="#ff8a5c" style="color:#fff" @click="shelves(scope.row.id,0)">下架</el-button>
					     		</span>
					     		<span v-else-if="scope.row.is_verify==1">
					     		</span>
					     		<span v-else>
					     			<el-button size="small"  color="#ff8a5c" style="color:#fff" @click="shelves(scope.row.id,1)">上架</el-button>
					     		</span>
					     								<span v-if="scope.row.is_up_shelves==1"> 上架
					     									
					     									
					     								</span>
					     								<span v-else>
					     									
					     									<el-button size="small" style="color:red" disabled>下架</el-button>
					     								</span>
					     							</template>
					     
					     </el-table-column> -->
							<el-table-column prop="is_import" label="数据类型" width="90" column-key="is_import" :filters="[
					        { text: 'APP', value: '1' },
					        { text: 'ERP', value: '2' },
					        { text: 'PC新建', value: '3' },
					        { text: '文档导入', value: '0' },
					      ]">
								<template #default="scope">
									<span v-if="scope.row.is_import==1">
										APP
									</span>
									<span v-else-if="scope.row.is_import==2">
										ERP
									</span>
									<span v-else-if="scope.row.is_import==3">
										PC新建
									</span>
									<span v-else>
										文档导入
									</span>
								</template>
							</el-table-column>
							<el-table-column prop="remark" label="备注" width="120" show-overflow-tooltip>
								<template #default="scope">
									<span v-if="scope.row.index === tabClickIndex && tabClickcolumn=='3' " @click.stop>
										<el-input v-bind:class="{'row_input': row_input!==scope.row.index+'3' }" :ref="'save_input'+scope.row.index+'3'" :id="'save_input'+scope.row.index+'3'" v-model="scope.row.remark" maxlength="300" size="mini" @blur="facePriceblur($event,scope.row,scope.row.index,'remark')" @focus="inputfocus(scope.row.index+'3',$event)" />
									</span>
									<span v-else>
										{{scope.row.remark}}
									</span>
								</template>
							</el-table-column>
							 <el-table-column prop="refuse_reason" :tooltip-formatter="({ row }) => row.refuse_reason" label="系统信息" width="90" show-overflow-tooltip >
					      	<template #default="scope">
					      	<div  class="caozuo" v-if="scope.row.refuse_reason">
					      		<el-icon size="18" color="red"><InfoFilled /></el-icon>
					      	</div>
									
							</template>
					      </el-table-column>
							

					      <el-table-column prop="real_price_margin" label="单利" width="80" align="right" header-align="right" show-overflow-tooltip />
					      <el-table-column prop="real_money_margin" label="总利" width="80" align="right" header-align="right" show-overflow-tooltip />
					     <el-table-column prop="address"  label="信息区域" width="90" column-key="date" :filters="[
					        { text: '滞纳区', value: '1' },
					        { text: '二手区', value: '2' },
					        { text: '认证区', value: '3' },
					      ]" />
						</el-table>
					</div>
				</el-col>
				<el-col :span="24" class="page" style="display: flex; justify-content: flex-end;">
					<el-pagination :pager-count="5" size="small" class="pagination" :current-page="page" background :page-size="parseInt(page_size)" layout="prev, pager, next" @current-change="handleCurrentChange" :total="total">
					</el-pagination>
				</el-col>
			</el-row>
		</div>
		<el-dialog title="分享" v-model="showShare"  width="40%" :close-on-click-modal='false' :close-on-press-escape='false' >
            <el-form  :model="shareForm">
                <el-form-item label="分享标题">
                    <el-input placeholder="请输入分享标题" class="shareInp" v-model="shareForm.title"></el-input>
                </el-form-item>
                <!-- <el-form-item label="一口总价">
          <el-input placeholder="请输入一口总价" class="shareInp" v-model="shareForm.price"></el-input>
        </el-form-item> -->
                <el-form-item label="货主备注">
                    <el-input placeholder="请输入您的联系方式，地址等" class="shareInp" type="textarea" :rows="3" v-model="shareForm.remark"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" style="text-align:right">
                <el-button @click="cancleShare" class="cancle_btn">取 消</el-button>
                <el-button class="set_btn" @click="sureShare">确 定</el-button>
            </div>
        </el-dialog>
        <el-dialog title="分享" :close-on-click-modal="false" v-model="showqr" width="250">
            <div id="qrcode" style="text-align:center"><qrcode-vue :value="QRCodeVue_text" v-if="QRCodeVue_text" :size="200" level="H" /></div>
            <div class="qrText" style="text-align:center">分享至微信朋友圈</div>
        </el-dialog>
		<examineImg ref="examineImg" v-on:cutImg="cutImg"></examineImg>
	</div>
</template>
<script>
import { ElMessage, ElMessageBox } from 'element-plus'
import { shallowRef } from 'vue'
import examineImg from '../public/img';
export default {
	components: {
		examineImg
	},
	data() {

		return {
			columns: [
				{ key: 'key', title: '行号', width: 55, cellRenderer: ({ rowData }) => rowData.key || '' },
				{ key: 'img', title: '图片', width: 55 },
				{ key: 'brand_name', title: '品牌', width: 90, cellRenderer: ({ rowData }) => rowData.brand_name || '' },
				{ key: 'name', title: '品名', width: 100, cellRenderer: ({ rowData }) => rowData.name || '' },
				{ key: 'model', title: '型号', width: 120, cellRenderer: ({ rowData }) => rowData.model || '' },
				{ key: 'order_no', title: '订货号', width: 120, cellRenderer: ({ rowData }) => rowData.order_no || '' },
				{ key: 'price', title: '列表价', width: 80, cellRenderer: ({ rowData }) => rowData.price || '' },
				{ key: 'discount', title: '折扣', width: 60, cellRenderer: ({ rowData }) => rowData.discount || '' },
				{ key: 'sur_num', title: '数量', width: 60, cellRenderer: ({ rowData }) => rowData.sur_num || '' },
				{ key: 'real_price', title: '单价', width: 80, cellRenderer: ({ rowData }) => rowData.real_price || '' },
				{ key: 'real_money', title: '金额', width: 80, cellRenderer: ({ rowData }) => rowData.real_money || '' },
				{ key: 'tsw_ratio', title: '脱手比例', width: 70, cellRenderer: ({ rowData }) => rowData.tsw_ratio || '' },
				{ key: 'tsw_price', title: '脱手单价', width: 70, cellRenderer: ({ rowData }) => rowData.tsw_price || '' },
				{ key: 'tsw_money', title: '脱手金额', width: 80, cellRenderer: ({ rowData }) => rowData.tsw_money || '' },
			],
			row_input: '', // 当前输入的输入框位置
			index_id: '',
			tabClickIndex: '', // 
			tabClickLabel: '', //
			tabClickcolumn: '', //
			index: [],
			SelectionChangeId: [],
			tableHeight: 500,
			srcList: [],
			input3: '',
			loading: false,
			total: 0,
			page: 1,
			page_size: 120,
			user_id: '',
			form: {},
			save_tableList: [],
			tableData: shallowRef([]),
			color_list: { //需要改变颜色的列
				real_money: 3, //显示的小数
				sur_num: 1, //显示的小数
				tsw_money: 3, //显示的小数
				real_money_margin: 3, //显示的小数
			},
			QRCodeVue_text:'',
			shareForm:{},
			showShare: false,
			showqr: false,

		}
	},
	props: ['activeName'],

	updated() {

	},


	beforeUnmount() {
		document.removeEventListener('click', this.handleClickOutside);
	},
	mounted() {
		document.addEventListener('click', this.handleClickOutside);
		this.$nextTick(() => {
			var obj = this;
			document.addEventListener('keyup', function(e){
				if (obj.tabClickIndex !== '' && obj.tabClickcolumn !== '' && obj.activeName=='manage') {
					if (e.keyCode == 40) { //下

						//alert(obj.tabClickIndex)
						obj.key_cut(1);
					} else if (e.keyCode == 38) { //上
						//alert(obj.tabClickIndex)
						obj.key_cut(2);
					}
				}
			});
			/*document.onkeyup = function(e) {
				console.log(12121)
				


			}*/
		})
	},

	activated() {

	},
	created() {

		this.path = this.$route.path.split('/')[1];
		this.user_id = localStorage.getItem('user_id');
		//查询当前页面的分页
		var page = JSON.parse(localStorage.getItem('page'));
		page = page ? page : {};
		var name = this.user_id + this.$route.path.split('/')[1];
		if (page[name]) {
			this.page_size = page[name];
		} else {
			this.page_size = 120;
			page[name] = this.page_size
			localStorage.setItem('page', JSON.stringify(page))
		}
		this.search()
		this.tableHeight_fun()
	},
	watch: {

	},
	methods: {
		showShare_click(){
			if (this.SelectionChangeId.length > 0) {
				this.showShare=true;
			} else {
				return ElMessage({
					message: '请先选中数据！',
					type: 'error',
					grouping: true // 开启合并功能
				})
			}
			
		},
		cancleShare() {
            this.showShare = false
            this.shareForm = {}
        },
        // 确认分享
        async sureShare() {
            if (!this.shareForm.title) {
            	return ElMessage({
						message: '请填写分享标题',
						type: 'error',
						grouping: true // 开启合并功能
					})
            } 
            this.shareForm.id=this.SelectionChangeId
            await this.$axios.post('/api/yunsys.storage/share', this.shareForm).then(async (res) => {
					var res = res.data;
					this.loading = false
					if (res.code !== 0) {
						return ElMessage({
							message: res.msg,
							type: 'error',
							grouping: true // 开启合并功能
						})
					}
					this.QRCodeVue_text=res.data.url
            
		            this.$nextTick(function() {
		            	this.showqr = true
			            this.showShare = false
			            this.shareForm = {}
		                
		            })
					/*return ElMessage({
						message: res.msg,
						type: 'success',
						grouping: true // 开启合并功能
					})*/

				})
				.catch(err => {
					this.loading = false
					return ElMessage({
						message: '系统错误',
						type: 'error',
						grouping: true // 开启合并功能

					})
				})
            
            
        },
		handleClickOutside(event) {
			// 检查点击是否发生在表格外部
			/*if (this.$refs.singleTable && !this.$refs.singleTable.$el.contains(event.target)) {
				console.log('点击了表格外部区域');
				// 在这里添加你的处理逻辑
				this.row_input = ''; // 当前输入的输入框位置
				this.index_id = '';
				this.tabClickIndex = ''; // 
				this.tabClickLabel = ''; //
				this.tabClickcolumn = ''; //
				this.index=[];
			}*/
		},
		ps_input() {
			this.page_size=this.page_size>200?200:this.page_size
			var page_size = this.page_size;
			var name = this.user_id + this.$route.path.split('/')[1];
			var page = JSON.parse(localStorage.getItem('page'));
			page[name] = this.page_size
			localStorage.setItem('page', JSON.stringify(page))
		},
		async updatestorage() {
			if (!this.save_tableList.length) {
				return ElMessage({
					message: '请先修改脱手比例！',
					type: 'error',
					grouping: true // 开启合并功能
				})
			}
			var data = [];

			this.save_tableList.forEach(function(item, index) {
				data.push({ id: item.id, tsw_ratio: item.tsw_ratio, tsw_price: item.tsw_price, tsw_money: item.tsw_money,remark:item.remark })
			})
			this.loading = true
			await this.$axios.post('/api/yunsys.storage/updatestorage', { date: data }).then(async (res) => {
					var res = res.data;
					this.loading = false
					if (res.code !== 0) {
						return ElMessage({
							message: res.msg,
							type: 'error',
							grouping: true // 开启合并功能
						})
					}
					this.save_tableList = [];
					this.search()
					return ElMessage({
						message: res.msg,
						type: 'success',
						grouping: true // 开启合并功能
					})

				})
				.catch(err => {
					this.loading = false
					return ElMessage({
						message: '系统错误',
						type: 'error',
						grouping: true // 开启合并功能

					})
				})
		},
		inputBlurTsw_price(index, v, row) {
			row.tsw_price = this.clearNoNum(v, 2)
			row.tsw_money = this.$bn.multiply(row.tsw_price, row.sur_num, 2);
			row.tsw_discount = this.$bn.multiply(row.tsw_price, row.price, 3);
			row.tsw_ratio = this.$bn.divide(row.tsw_price, row.real_price, 2);
			row.real_price_margin = this.$bn.subtract(row.tsw_price, row.real_price, 2);
			row.real_money_margin = this.$bn.subtract(row.tsw_money, row.real_money, 2);


		},
		inputBlurDiscount(index, v, row) {
			row.tsw_ratio = this.clearNoNum(v, 2)
			row.tsw_price = this.$bn.multiply(row.real_price, row.tsw_ratio, 2)
			row.tsw_money = this.$bn.multiply(row.tsw_price, row.sur_num, 2);
			row.tsw_discount = this.$bn.multiply(row.tsw_price, row.price, 3);
			row.real_price_margin = this.$bn.subtract(row.tsw_price, row.real_price, 2);
			row.real_money_margin = this.$bn.subtract(row.tsw_money, row.real_money, 2);


		},
		inputfocus(index, e) {
			this.row_input = index
			if (e.target.select) {
				e.target.select()
			}
		},
		facePriceblur(v, row, index, name) {
			if (name!='remark') {
				row[name] = this.$bn.multiply(row[name], 1, 2)
			}
			
			if (this.save_tableList.length > 0) {
				var obj = this
				var info = 0;
				this.save_tableList.forEach(function(item, index) {
					if (row.id == item.id && typeof item.id != "undefined") {
						item = row;
						info = 1;
					}
				})
				if (info === 0) {
					this.save_tableList.push(row);
				}
			} else {
				this.save_tableList.push(row);
			}
			console.log(this.save_tableList)
		},
		tableRowClassName({
			row,
			rowIndex
		}) {
			row.index = rowIndex
			return ''
		},
		addStyle({ row, rowIndex }) {
			if (this.index.indexOf(rowIndex) > -1) {
                return { 'background-color': 'rgba(255, 138, 92, 0.6)' }
            }else if( row.is_up_shelves==1){
            	//return { 'background-color': 'rgba(247, 248, 250,1)' }
            }else if(row.is_verify==1){
            	//return { 'background-color': 'rgba(247, 248, 250,1)' }
            }else{
            	return { 'background-color': 'rgba(247, 248, 250,1)' }
            }
		},
		clearNoNum(value, decimals) {
			//先把非数字的都替换掉，除了数字和. 
			value = value.replace(/[^\d.]/g, "");
			//保证只有出现一个.而没有多个. 
			value = value.replace(/\.{2,}/g, ".");
			//必须保证第一个为数字而不是. 
			value = value.replace(/^\./g, "");
			//保证.只出现一次，而不能出现两次以上 
			value = value.replace(".", "$#$").replace(/\./g, "").replace("$#$", ".");
			//只能输入四个小数 (\d\d\d\d)
			return value.replace(eval("/^(\\-)*(\\d+)\\.(\\d{1," + decimals + "}).*$/"), '$1$2.$3')

		},
		key_cut(info) {
			var tabClickIndex = '';
			var obj = this;
			if (info == 1) { //下
				var type = 1;
				this.tableData.forEach(function(item, index) {
					if (index > obj.tabClickIndex  && type) {
						tabClickIndex = index;
						type = 0;
					}
				})

			} else { // 上
				this.tableData.forEach(function(item, index) {
					if (index < obj.tabClickIndex ) {
						tabClickIndex = index;
					}
				})
			}

			if (tabClickIndex !== '') {
				var name = '';
				/*if (this.tabClickcolumn == 1) {
					name = "discount"
					this.tableData[this.tabClickIndex][name] = this.$bn.multiply(this.tableData[this.tabClickIndex][name], 1, 0)
				} else if (this.tabClickcolumn == 2) {
					name = "real_price"
					this.tableData[this.tabClickIndex][name] = this.$bn.multiply(this.tableData[this.tabClickIndex][name], 1, 0)
				} else if (this.tabClickcolumn == 3) {
					name = "num"
				} else if (this.tabClickcolumn == 8) {
					name = "price"
				}*/
				this.facePriceblur('', this.tableData[this.tabClickIndex]);
				this.tabClickIndex = tabClickIndex
				this.$nextTick(() => {
					document.getElementById('save_input' + parseInt(tabClickIndex) + this.tabClickcolumn).focus()

				})

			}

		},
		tabClick(row, column, cell, event) {
			var c;
			row.index = parseInt(row.index)
			switch (column.label) {
				case '脱手比例':
					this.tabClickIndex = row.index
					this.tabClickLabel = column.label
					this.tabClickcolumn = 1
					c = 1
					break
				case '脱手单价':
					this.tabClickIndex = row.index
					this.tabClickLabel = column.label
					this.tabClickcolumn = 2
					c = 1
					break
				case '备注':
					this.tabClickIndex = row.index
					this.tabClickLabel = column.label
					this.tabClickcolumn = 3
					c = 1
					break
				default:
					return
			}


			this.$nextTick(() => {
				document.getElementById('save_input' + parseInt(row.index) + this.tabClickcolumn).focus()
			})

		},
		rowClick(row, column, e) {
			this.tabClickIndex = parseInt(row.index)
			this.index = [parseInt(row.index)] //选中行this.tabClickcolumn = 1
			this.$refs.singleTable.setCurrentRow(this.tableData[parseInt(row.index)]);
		},
		shelves_lise(is_up_shelves) {
			if (this.SelectionChangeId.length > 0) {
				ElMessageBox.confirm(
						is_up_shelves ? '确认批量上架数据！' : '确认批量下架数据！',
						'提示', {
							confirmButtonText: '确认',
							cancelButtonText: '取消',
							type: 'warning',
						}
					)
					.then(() => {
						this.shelves_ajax(this.SelectionChangeId, is_up_shelves)
					})
					.catch(() => {

					})
			} else {
				return ElMessage({
					message: '请先选中数据！',
					type: 'error',
					grouping: true // 开启合并功能
				})
			}

		},
		shelves(id, is_up_shelves) {
			ElMessageBox.confirm(
					is_up_shelves ? '确认上架此数据！' : '确认下架此数据！',
					'提示', {
						confirmButtonText: '确认',
						cancelButtonText: '取消',
						type: 'warning',
					}
				)
				.then(() => {
					this.shelves_ajax([id], is_up_shelves)
				})
				.catch(() => {

				})
		},
		async shelves_ajax(ids, is_up_shelves) {
			this.loading = true
			await this.$axios.post('/api/yunsys.storage/verifystorage', { ids, is_up_shelves }).then(async (res) => {
					var res = res.data;
					this.loading = false
					if (res.code !== 0) {
						return ElMessage({
							message: res.msg,
							type: 'error',
							grouping: true // 开启合并功能
						})
					}
					this.search()
					return ElMessage({
						message: res.msg,
						type: 'success',
						grouping: true // 开启合并功能
					})

				})
				.catch(err => {
					this.loading = false
					return ElMessage({
						message: '系统错误',
						type: 'error',
						grouping: true // 开启合并功能

					})
				})
		},
		handleSelectionChange(data) {
			var ids = [];
			data.forEach(function(item) {
				ids.push(item.id);
			})
			this.SelectionChangeId = ids
		},
		//退回
		checkundostorage() {
			if (this.SelectionChangeId.length > 0) {
				ElMessageBox.confirm(
						'确认退回数据！',
						'提示', {
							confirmButtonText: '确认',
							cancelButtonText: '取消',
							type: 'warning',
						}
					)
					.then(() => {
						this.checkundostorage_ajax();
					})
					.catch(() => {

					})

			} else {
				return ElMessage({
					message: '请先选中数据！',
					type: 'error',
					grouping: true // 开启合并功能
				})
			}
		},
		async checkundostorage_ajax() {
			this.loading = true
			await this.$axios.post('/api/yunsys.storage/checkundostorage', { ids: this.SelectionChangeId }).then(async (res) => {
					var res = res.data;
					this.loading = false
					if (res.code !== 0) {
						return ElMessage({
							message: res.msg,
							type: 'error',
							grouping: true // 开启合并功能
						})
					}
					this.page = 1;
					this.search()
					this.$emit('pcsummary', {});
					return ElMessage({
						message: res.msg,
						type: 'success',
						grouping: true // 开启合并功能
					})

				})
				.catch(err => {
					this.loading = false
					return ElMessage({
						message: '系统错误',
						type: 'error',
						grouping: true // 开启合并功能

					})
				})
		},
		filterHandler(filters) {
			if (typeof filters.is_up_shelves != "undefined") {
				this.form.is_up_shelves = filters.is_up_shelves;
			}
			if (typeof filters.is_import != "undefined") {
				this.form.is_import = filters.is_import;
			}
			if (typeof filters.stock_type_txt != "undefined") {
				this.form.stock_type_txt = filters.stock_type_txt;
			}
			this.page = 1;
			console.log(filters.state, 1)
			this.search();
		},
		tableHeight_fun() {
			this.$nextTick(() => {
				this.tableHeight = window.innerHeight - this.$refs.height_top.getBoundingClientRect().top - 100
				console.log(this.tableHeight, 12122)
			})
		},
		cutImg(index,info){ //1 上 2 下1
			if (index<0) {
				return ElMessage({
					message: '无上一个产品',
					type: 'error',
					grouping: true // 开启合并功能

				})
			}else if(this.tableData[index]){

				this.tabClickIndex = parseInt(index)
				this.index = [parseInt(index)] //选中行this.tabClickcolumn = 1
				this.$refs.singleTable.setCurrentRow(this.tableData[parseInt(index)]);
				this.preview(this.tableData[index],this.tableData[index]['img'])
			}else{
				return ElMessage({
					message: '无下一个产品',
					type: 'error',
					grouping: true // 开启合并功能

				})
			}
		},
		preview(row, img) {
			this.srcList = [];
			/*this.srcList_index = 0
			this.showPreview = true;*/
			var obj = this;
			img.forEach(function(item) {
				obj.srcList.push(item)
			})
			this.$refs['examineImg'].cutImg_info = true;
			this.$refs['examineImg'].img_title = row;
			this.$refs['examineImg'].data = this.srcList;
			this.$refs['examineImg'].dialogTableVisible = true;
			this.$refs['examineImg'].imgBigUrl = this.srcList[0];
		},
		rowDblclick(row) {
			/*const newUrl = this.$router.resolve({ path: '/product', query: { id: row.id } }).href;
			window.open(newUrl, '_blank');*/
		},
		handleCurrentChange(val) {
			this.page = val;
			this.search();
		},
		grabble() {
			this.save_tableList = [];
			this.page = 1;
			this.search();
			this.$emit('pcsummary', {});
		},
		getSummaries(param) {
			var obj = this;
			const {
				columns,
				data
			} = param
			const sums = []
			columns.forEach((column, index) => {
				if (index === 0) {
					sums[index] = '合计'
					return
				}
				const values = data.map(item => Number(item[column.property]))
				if (this.color_list[column.property]) {
					sums[index] = values.reduce((prev, curr) => {
						const value = Number(curr)
						if (!isNaN(value)) {
							return this.$bn.add(prev, curr, this.color_list[column.property] - 1)

						} else {

							return this.$bn.multiply(prev, 1, this.color_list[column.property] - 1)
						}
					}, 0)
				} else {
					sums[index] = ''
				}
			})
			return sums
		},
		async search() {
			this.row_input = ''; // 当前输入的输入框位置
			this.index_id = '';
			this.tabClickIndex = ''; // 
			this.tabClickLabel = ''; //
			this.tabClickcolumn = ''; //
			this.index = []; //

			this.loading = true
			var search = this.form;
			search.page = this.page;
			search.ps = this.page_size;
			await this.$axios.post('/api/yunsys.Storage/getownstorage', search).then(async (res) => {
					var res = res.data;
					this.loading = false
					if (res.code !== 0) {
						return ElMessage({
							message: res.msg,
							type: 'error',
							grouping: true // 开启合并功能
						})
					}
					var obj = this;
					this.total = res.data.total;
					var key = 0;
					res.data.data.forEach(item => {
						key = key + 1
						item.key = (obj.page - 1) * obj.page_size + key
						item.real_money = obj.$bn.multiply(item.sur_num, item.real_price, 2);
						item.real_price = obj.$bn.multiply(item.real_price, 1, 2);
						item.tsw_ratio = obj.$bn.multiply(item.tsw_ratio, 1, 2);
						item.tsw_price = obj.$bn.multiply(item.tsw_price, 1, 2);
						item.tsw_money = obj.$bn.multiply(item.tsw_money, 1, 2);
						item.discount = obj.$bn.multiply(item.discount, 1, 3);
						item.real_price_margin = obj.$bn.subtract(item.tsw_price, item.real_price, 2);
						item.real_money_margin = obj.$bn.subtract(item.tsw_money, item.real_money, 2);
						//item.discount_calculate = obj.$bn.divide(item.real_price, item.price, 4)
					})
					this.tableData = res.data.data;

				})
				.catch(err => {
					this.loading = false
					return ElMessage({
						message: '系统错误',
						type: 'error',
						grouping: true // 开启合并功能

					})
				})
		}
	}
}
</script>
<style lang="less" scoped>
/* 需求 下方的滚动条和合计的栏目中间有一条缝隙  取消合计行与滚动条的间隙 */
:deep(.el-table__footer-wrapper) {
	margin-top: -2px;
}

:deep(.el-input-group__append) {
	background: #ff8a5c;
}

:deep(.el-table__body tr td:nth-child(n+13):nth-child(-n+14)) {
	border-top: 2px solid #dadada;
	border-right: 2px solid #dadada;
}

:deep(.el-table__body tr:last-child td:nth-child(n+13):nth-child(-n+14)) {
	border-bottom: 2px solid #dadada !important;
	position: relative;
	z-index: 1900;
}



:deep(.el-table__body tr td:nth-child(13)) {
	border-left: 2px solid #dadada;
}


.row_input input {
	background-color: transparent;
}
</style>